import axios from 'axios'

export default {
    name: 'popularEntryList',
    data() {
        let entries;
        return {
            entries: entries,
        }
    },
    created() {
        this.loadEntries();
    },
    methods: {
        loadEntries: function () {
            axios.get('/popular', {
                params: {
                    "limit": 3,
                    "format": "json"
                }
            })
                .then((response) => {
                    this.entries = [];
                    for (let entryData of response.data.entries) {
                        let entry = {
                            title: entryData.title,
                            url: entryData.url,
                            domain: entryData.domain,
                            entryPageUrl: entryData.entryPageUrl,
                            signal: entryData.signal,
                            signalClass: "signal" + entryData.signal,
                            commentCountSummary: entryData.commentCountSummary
                        };
                        this.entries.push(entry);
                    }
                });
        }
    }
}

